import { FC } from "react";
import { LawyerOrLawFirmStatus } from "../../model/registrationEnums";
import { isIneligibleLawFirm } from "../../eligibility/participantEligibilityRules";
import { IneligibleLawFirmNotice } from "./IneligibleLawFirmNotice";
import { IneligibleTitleNotice } from "./IneligibleTitleNotice";
import { LawyerOrLawFirmSelectField } from "./LawyerOrLawFirmSelectField";
import { LeavesOtherOnEntryField } from "./LeavesOtherOnEntryField";

type InteressentskabCreationParticipantEligibilityFieldsProps = {
  namePrefix: string;
  idPrefix: string;
  isLawyerOrLawFirm: string;
  passedPartnerExam: string;
  leavesOtherOnEntry: string;
};

const INELIGIBLE_TITLE = "Denne deltager kan ikke tilføjes.";

// Afsnittene samles med "\n\n", fordi hjælpetekst-renderingen deler strengen op
// i egentlige <p>-afsnit. Må ikke skrives som en JSX-attribut-streng: der bliver
// \n ikke fortolket som linjeskift, men vist som tegnene \ og n.
const LEAVES_OTHER_ON_ENTRY_HELPER = [
  "Hvis du hermed udtræder af partnerkredsen på din tidligere arbejdsplads, skal din tidligere arbejdsplads udfylde en blanket vedrørende ændring i partnerkredsen.",
  "Du kan godt være tilknyttet flere steder på en gang, hvorfor den tidligere firmarelation ikke nødvendigvis skal afsluttes.",
  'Hvis et andet advokatfirma ophører med at drive advokatvirksomhed samtidigt med denne ændring, skal det pågældende firma enten (1) registreres som ophørt i CVR-registret, eller også (2) skal navnet på virksomheden ændres, så "advokat" ikke længere fremgår, ligesom et eventuelt formål ikke længere skal være "at drive advokatvirksomhed / at eje aktier/anparter i et andet advokatselskab", jf. retsplejelovens §§ 120, 124, stk. 2 og 124 a samt advokatselskabsbekendtgørelsen § 20.',
].join("\n\n");

export const InteressentskabCreationParticipantEligibilityFields: FC<
  InteressentskabCreationParticipantEligibilityFieldsProps
> = ({
  namePrefix,
  idPrefix,
  isLawyerOrLawFirm,
  passedPartnerExam,
  leavesOtherOnEntry,
}) => (
  <div className="d-flex flex-column gap-4">
    <LawyerOrLawFirmSelectField
      namePrefix={namePrefix}
      idPrefix={idPrefix}
      label="Er deltageren advokat eller advokatselskab?"
    />
    {isIneligibleLawFirm(isLawyerOrLawFirm) && (
      <IneligibleLawFirmNotice title={INELIGIBLE_TITLE} />
    )}
    {isLawyerOrLawFirm === LawyerOrLawFirmStatus.IkkeAdvokat && (
      <IneligibleTitleNotice title={INELIGIBLE_TITLE} />
    )}
    <LeavesOtherOnEntryField
      namePrefix={namePrefix}
      idPrefix={idPrefix}
      isLawyerOrLawFirm={isLawyerOrLawFirm}
      passedPartnerExam={passedPartnerExam}
      leavesOtherOnEntry={leavesOtherOnEntry}
      label="Ophører interessentens tilknytning til en anden virksomhed samtidigt med indtræden i denne?"
      helperWhenJa={LEAVES_OTHER_ON_ENTRY_HELPER}
    />
  </div>
);
